import {
  KentNodeClass,
  KarpenterResourceCondition,
  KentNodePool,
  KentNodeOverlay,
} from '@cast/types-kent';

// The 'Ready' condition aggregates all other status conditions into a single readiness signal
const AGGREGATE_STATUS_CONDITION_TYPE = 'Ready';

export const isResourceReady = (
  resource: KentNodePool | KentNodeClass | KentNodeOverlay
): boolean => {
  const conditions = resource.status?.conditions;
  const readyCondition = conditions?.find(
    (condition) => condition.type === AGGREGATE_STATUS_CONDITION_TYPE
  );
  if (!readyCondition) {
    return false;
  }

  return readyCondition.status === 'True';
};

export const getUnmetResourceConditions = (
  resource: KentNodePool | KentNodeClass | KentNodeOverlay
): KarpenterResourceCondition[] => {
  const conditions = resource.status?.conditions || [];
  return conditions.filter(
    (condition) =>
      condition.status !== 'True' &&
      condition.type !== AGGREGATE_STATUS_CONDITION_TYPE
  );
};
